export function NodeStructure({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7809_34613)">
          <mask id="mask0_7809_34613" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <path d="M16 0H0V16H16V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_7809_34613)">
            <path
              d="M13.8932 11.3136H13.6532V9.84027C13.6532 8.7536 12.7666 7.86693 11.6799 7.86693H8.49325V5.9269H11.0532C12.2132 5.9269 13.1466 4.9869 13.1466 3.83357C13.1466 2.68023 12.2066 1.74023 11.0532 1.74023H4.93994C3.77994 1.74023 2.84661 2.68023 2.84661 3.83357C2.84661 4.9869 3.78661 5.9269 4.93994 5.9269H7.49991V7.86693H4.31327C3.22661 7.86693 2.33994 8.7536 2.33994 9.84027V11.3136H2.09994C1.69327 11.3136 1.35994 11.6469 1.35994 12.0536V13.5269C1.35994 13.9336 1.69327 14.2669 2.09994 14.2669H3.57327C3.97994 14.2669 4.31327 13.9336 4.31327 13.5269V12.0536C4.31327 11.6469 3.97994 11.3136 3.57327 11.3136H3.33994V9.84027C3.33994 9.30693 3.77994 8.86693 4.31327 8.86693H7.49991V11.3136H7.25991C6.85325 11.3136 6.51994 11.6469 6.51994 12.0536V13.5269C6.51994 13.9336 6.85325 14.2669 7.25991 14.2669H8.73325C9.13991 14.2669 9.47325 13.9336 9.47325 13.5269V12.0536C9.47325 11.6469 9.13991 11.3136 8.73325 11.3136H8.49325V8.86693H11.6799C12.2132 8.86693 12.6532 9.30693 12.6532 9.84027V11.3136H12.4199C12.0132 11.3136 11.6799 11.6469 11.6799 12.0536V13.5269C11.6799 13.9336 12.0132 14.2669 12.4199 14.2669H13.8932C14.2999 14.2669 14.6332 13.9336 14.6332 13.5269V12.0536C14.6332 11.6469 14.2999 11.3136 13.8932 11.3136Z"
              fill="#82B2C0"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_7809_34613">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}
